export default {
    computed: {
        isPublic() {
            return this.$route.params.player != undefined;
        },
    },

}